import { Component, inject } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatIcon } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { MeasuresActions } from '@store/actions/measures/measures.actions';
import { IMeasure } from '@models/measures.model';


@Component({
  selector: 'app-measures-table-actions',
  imports: [MatIcon],
  templateUrl: './measures-table-actions.component.html',
  styleUrl: './measures-table-actions.component.css',
  standalone: true
})
export class MeasuresTableActionsComponent implements ICellRendererAngularComp {

  private readonly store = inject(Store);

  params: any;
  agInit(params: ICellRendererParams<any, any, any>): void {
   this.params = params;
  }
  refresh(params: ICellRendererParams<any, any, any>): boolean {
   this.params = params;
   return true;
  }
  editMeasure() {
    const measure: IMeasure = {
      id: Number(this.params.data.id),
      title: this.params.data.title,
      description: this.params.data.description,
      eMeasure_Measure_identifier: this.params.data.eMeasure_Measure_identifier,
      qpP_identifier: this.params.data.qpP_identifier,
      measureTypeID: this.params.data.measureTypeID,
      highPriority: (this.params.data.highPriority == 1)? true : false,
      researchNetworkID: 0,
      registryID: 0,
      nqF_eMeasure_identifier: null,
      nqF_identifier: '',
      measureAggregationTypeID: 0,
      createUserID: 0
    }

    this.store.dispatch(MeasuresActions.setMeasureToEdit( { measure }));
  }

  deleteMeasure() {
    alert(this.params.getValue());
  }
}
